var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.ready
        ? _c(
            "div",
            [
              _c("div", { staticClass: "q-headline" }, [
                _vm._v("Companies Pending Approval")
              ]),
              _c(
                "q-card",
                { staticClass: "mdi-card q-mb-lg" },
                [
                  _c(
                    "q-card-main",
                    { staticClass: "q-pa-none" },
                    [
                      _vm.companies &&
                      _vm.companies.length > 0 &&
                      _vm.companyTable.columns
                        ? _c("q-table", {
                            attrs: {
                              title: "Companies Pending Approval",
                              data: _vm.companies,
                              columns: _vm.companyTable.columns,
                              "row-key": "id",
                              selection: "multiple",
                              selected: _vm.companyTable.selected,
                              dense: "",
                              filter: _vm.companyTable.terms,
                              "filter-method": _vm.companyTable.myFilter,
                              pagination: _vm.companyTable.pagination,
                              "rows-per-page-options": [
                                0,
                                25,
                                50,
                                100,
                                250,
                                500
                              ]
                            },
                            on: {
                              "update:selected": function($event) {
                                return _vm.$set(
                                  _vm.companyTable,
                                  "selected",
                                  $event
                                )
                              },
                              "update:pagination": function($event) {
                                return _vm.$set(
                                  _vm.companyTable,
                                  "pagination",
                                  $event
                                )
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "top",
                                  fn: function(props) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "full-width q-pt-sm q-pb-sm"
                                      },
                                      [
                                        _c(
                                          "transition",
                                          {
                                            attrs: {
                                              mode: "out-in",
                                              "enter-active-class":
                                                "animated flipInX",
                                              "leave-active-class":
                                                "animated flipOutX"
                                            }
                                          },
                                          [
                                            !_vm.companyTable.selected.length
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: "search-bar",
                                                    staticClass:
                                                      "row flex-center gutter-md",
                                                    staticStyle: {
                                                      "animation-duration":
                                                        "0.4s"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-6" },
                                                      [
                                                        _c("q-search", {
                                                          attrs: {
                                                            "hide-underline": ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.companyTable
                                                                .terms,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.companyTable,
                                                                "terms",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "companyTable.terms"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col text-right"
                                                      },
                                                      [
                                                        _c("q-btn", {
                                                          attrs: {
                                                            flat: "",
                                                            round: "",
                                                            dense: "",
                                                            icon: props.inFullscreen
                                                              ? "fullscreen_exit"
                                                              : "fullscreen"
                                                          },
                                                          on: {
                                                            click:
                                                              props.toggleFullscreen
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    key: "bulk-update-bar",
                                                    staticClass:
                                                      "row flex-center gutter-md",
                                                    staticStyle: {
                                                      "animation-duration":
                                                        "0.4s"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col text-right"
                                                      },
                                                      [
                                                        _c("q-btn", {
                                                          attrs: {
                                                            color: "positive",
                                                            flat: "",
                                                            delete: "",
                                                            label:
                                                              "Approve Selected",
                                                            icon: "add"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.handleBatchApprove(
                                                                "company"
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }
                                },
                                {
                                  key: "header",
                                  fn: function(props) {
                                    return _c(
                                      "q-tr",
                                      {},
                                      [
                                        _c(
                                          "q-th",
                                          { attrs: { "auto-width": "" } },
                                          [
                                            props.multipleSelect
                                              ? _c("q-checkbox", {
                                                  attrs: {
                                                    "indeterminate-value":
                                                      "some"
                                                  },
                                                  model: {
                                                    value: props.selected,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        props,
                                                        "selected",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "props.selected"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._l(props.cols, function(col) {
                                          return _c(
                                            "q-th",
                                            {
                                              key: col.name,
                                              attrs: { props: props }
                                            },
                                            [_vm._v(_vm._s(col.label))]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  }
                                },
                                {
                                  key: "body",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "q-tr",
                                        { attrs: { props: props } },
                                        [
                                          _c(
                                            "q-td",
                                            { attrs: { "auto-width": "" } },
                                            [
                                              _c("q-checkbox", {
                                                attrs: { color: "primary" },
                                                model: {
                                                  value: props.selected,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      props,
                                                      "selected",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "props.selected"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "id",
                                              attrs: { props: props }
                                            },
                                            [
                                              _c("q-btn", {
                                                attrs: {
                                                  icon: "pageview",
                                                  flat: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openCompareModal(
                                                      props.row,
                                                      "company"
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "isNew",
                                              attrs: { props: props }
                                            },
                                            [
                                              props.row.isNew
                                                ? _c("q-icon", {
                                                    attrs: {
                                                      name: "check",
                                                      color: "positive"
                                                    }
                                                  })
                                                : _c("q-icon", {
                                                    attrs: {
                                                      name: "clear",
                                                      color: "faded"
                                                    }
                                                  })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "name",
                                              attrs: { props: props }
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(_vm._s(props.row.name))
                                              ])
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "membershipRegistrationDate",
                                              attrs: { props: props }
                                            },
                                            [
                                              props.row.membership &&
                                              props.row.membership
                                                .membershipPeriod &&
                                              props.row.membership
                                                .membershipPeriod[0] &&
                                              props.row.membership
                                                .membershipPeriod[0]
                                                .registrationDate
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatDate")(
                                                          props.row.membership
                                                            .membershipPeriod[0]
                                                            .registrationDate
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "membershipType",
                                              attrs: { props: props }
                                            },
                                            [
                                              props.row.membership &&
                                              props.row.membership
                                                .membershipType &&
                                              props.row.membership
                                                .membershipType.description
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.row.membership
                                                          .membershipType
                                                          .description
                                                      )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "phoneNumber",
                                              attrs: { props: props }
                                            },
                                            [
                                              props.row.phoneNumber
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.row.phoneNumber
                                                      )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "primaryEmail",
                                              attrs: { props: props }
                                            },
                                            [
                                              props.row.primaryPerson &&
                                              props.row.primaryPerson
                                                .emailAddress
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.row.primaryPerson
                                                          .emailAddress
                                                      )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "primaryPhone",
                                              attrs: { props: props }
                                            },
                                            [
                                              props.row.primaryPerson &&
                                              props.row.primaryPerson.workNumber
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.row.primaryPerson
                                                          .workNumber
                                                      )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4247079862
                            )
                          })
                        : _c("q-alert", { attrs: { type: "negative" } }, [
                            _vm._v("No companies pending approval")
                          ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "q-headline" }, [
                _vm._v("Persons Pending Approval")
              ]),
              _c(
                "q-card",
                { staticClass: "mdi-card q-mb-lg" },
                [
                  _c(
                    "q-card-main",
                    { staticClass: "q-pa-none" },
                    [
                      _vm.filteredPersons &&
                      _vm.filteredPersons.length > 0 &&
                      _vm.personTable.columns
                        ? _c("q-table", {
                            attrs: {
                              title: "Persons Pending Approval",
                              data: _vm.filteredPersons,
                              columns: _vm.personTable.columns,
                              "row-key": "id",
                              selection: "multiple",
                              selected: _vm.personTable.selected,
                              dense: "",
                              filter: _vm.personTable.terms,
                              "filter-method": _vm.personTable.myFilter,
                              pagination: _vm.personTable.pagination,
                              "rows-per-page-options": [
                                0,
                                25,
                                50,
                                100,
                                250,
                                500
                              ]
                            },
                            on: {
                              "update:selected": function($event) {
                                return _vm.$set(
                                  _vm.personTable,
                                  "selected",
                                  $event
                                )
                              },
                              "update:pagination": function($event) {
                                return _vm.$set(
                                  _vm.personTable,
                                  "pagination",
                                  $event
                                )
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "top",
                                  fn: function(props) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "full-width q-pt-sm q-pb-sm"
                                      },
                                      [
                                        _c(
                                          "transition",
                                          {
                                            attrs: {
                                              mode: "out-in",
                                              "enter-active-class":
                                                "animated flipInX",
                                              "leave-active-class":
                                                "animated flipOutX"
                                            }
                                          },
                                          [
                                            !_vm.personTable.selected.length
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: "search-bar",
                                                    staticClass:
                                                      "row flex-center gutter-md",
                                                    staticStyle: {
                                                      "animation-duration":
                                                        "0.4s"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-6" },
                                                      [
                                                        _c("q-search", {
                                                          attrs: {
                                                            "hide-underline": ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.personTable
                                                                .terms,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.personTable,
                                                                "terms",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "personTable.terms"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col text-right"
                                                      },
                                                      [
                                                        _c("q-btn", {
                                                          attrs: {
                                                            flat: "",
                                                            round: "",
                                                            dense: "",
                                                            icon: props.inFullscreen
                                                              ? "fullscreen_exit"
                                                              : "fullscreen"
                                                          },
                                                          on: {
                                                            click:
                                                              props.toggleFullscreen
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    key: "bulk-update-bar",
                                                    staticClass:
                                                      "row flex-center gutter-md",
                                                    staticStyle: {
                                                      "animation-duration":
                                                        "0.4s"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col text-right"
                                                      },
                                                      [
                                                        _c("q-btn", {
                                                          attrs: {
                                                            color: "positive",
                                                            flat: "",
                                                            delete: "",
                                                            label:
                                                              "Approve Selected",
                                                            icon: "add"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.handleBatchApprove(
                                                                "person"
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }
                                },
                                {
                                  key: "header",
                                  fn: function(props) {
                                    return _c(
                                      "q-tr",
                                      {},
                                      [
                                        _c(
                                          "q-th",
                                          { attrs: { "auto-width": "" } },
                                          [
                                            props.multipleSelect
                                              ? _c("q-checkbox", {
                                                  attrs: {
                                                    "indeterminate-value":
                                                      "some"
                                                  },
                                                  model: {
                                                    value: props.selected,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        props,
                                                        "selected",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "props.selected"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._l(props.cols, function(col) {
                                          return _c(
                                            "q-th",
                                            {
                                              key: col.name,
                                              attrs: { props: props }
                                            },
                                            [_vm._v(_vm._s(col.label))]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  }
                                },
                                {
                                  key: "body",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "q-tr",
                                        { attrs: { props: props } },
                                        [
                                          _c(
                                            "q-td",
                                            { attrs: { "auto-width": "" } },
                                            [
                                              _c("q-checkbox", {
                                                attrs: { color: "primary" },
                                                model: {
                                                  value: props.selected,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      props,
                                                      "selected",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "props.selected"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "id",
                                              attrs: { props: props }
                                            },
                                            [
                                              _c("q-btn", {
                                                attrs: {
                                                  icon: "pageview",
                                                  flat: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openCompareModal(
                                                      props.row,
                                                      "person"
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "isNew",
                                              attrs: { props: props }
                                            },
                                            [
                                              props.row.isNew
                                                ? _c("q-icon", {
                                                    attrs: {
                                                      name: "check",
                                                      color: "positive"
                                                    }
                                                  })
                                                : _c("q-icon", {
                                                    attrs: {
                                                      name: "clear",
                                                      color: "faded"
                                                    }
                                                  })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "firstName",
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(props.row.firstName)
                                              )
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "lastName",
                                              attrs: { props: props }
                                            },
                                            [_vm._v(_vm._s(props.row.lastName))]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "profession",
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(props.row.profession)
                                              )
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "email",
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(props.row.emailAddress)
                                              )
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "phone",
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(props.row.workNumber)
                                              )
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "updatedAt",
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("formatDate")(
                                                    props.row.updatedAt
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              528744364
                            )
                          })
                        : _c("q-alert", { attrs: { type: "negative" } }, [
                            _vm._v("No persons pending approval")
                          ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-modal",
                {
                  attrs: {
                    "content-classes": "q-pa-lg",
                    "content-css": "min-width: 70vw; max-width: 95vw",
                    "no-backdrop-dismiss": "",
                    "no-esc-dismiss": ""
                  },
                  model: {
                    value: _vm.compareFormModalOpen,
                    callback: function($$v) {
                      _vm.compareFormModalOpen = $$v
                    },
                    expression: "compareFormModalOpen"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "fit" },
                    [
                      _c("q-btn", {
                        staticStyle: {
                          top: "0",
                          right: "0",
                          position: "relative",
                          float: "right"
                        },
                        attrs: { flat: "", icon: "close" },
                        on: {
                          click: function($event) {
                            _vm.compareFormModalOpen = false
                          }
                        }
                      }),
                      _vm.compareFormModalOpen &&
                      _vm.compareFormNewRecord &&
                      _vm.compareFormRelationResource
                        ? _c("compare-form", {
                            key: _vm.compareFormComponentKey,
                            attrs: {
                              "relation-resource":
                                _vm.compareFormRelationResource,
                              "new-record": _vm.compareFormNewRecord
                            },
                            on: {
                              approve: _vm.handleFormApprove,
                              deny: _vm.handleFormDeny
                            }
                          })
                        : _c("div", [_vm._v("No record found")])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "full-width q-mt-md q-pb-lg" },
                    [
                      _c("q-btn", {
                        attrs: {
                          icon: "close",
                          label: "Cancel / Close",
                          color: "grey-6",
                          flat: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.compareFormModalOpen = false
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c("q-inner-loading", { attrs: { visible: _vm.loading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }